import styled from 'styled-components'

const Email = styled.a`
    color: #FFF;
    text-decoration: none;
    margin-top: 10px;
    transition: .5s ease;
    &:hover{
        color: rgba(255,255,255,.5);
    }
`
export default Email;